import { createColumnHelper, CellContext } from "@tanstack/react-table";
import React, { useState } from "react";
import Loading from "../../../../cross/Loading";
import { EnumEstadoAuditoria } from "../../../../entities/helper/EnumEstadoAuditoria";
import { EnumEstadoProgramaAuditoria } from "../../../../entities/helper/EnumEstadoProgramaAuditoria";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import IAuditoria from "../../../../entities/IAuditoria";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { PathsAuditoria } from "../../../../helpers/pathDocumentsHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import {
  cognitoUserInfo,
  cognitoUserToken,
} from "../../../../helpers/userHelper";
import {
  API_AUDITORIA,
  API_AUDITORIA_GETALL_PLANESAUDITORIAS,
  API_AUDITORIA_GET_PROGRAMAAUDITORIA,
  API_AUDITORIA_POST_AUDITORIA_APROBARPROGRAMAAUDITORIA,
  ROW_COUNT,
} from "../../../../helpers/variableHelper";
import AuditoriaService from "../../../../services/AuditoriaService";
import AdminLista from "../../../administration/AdminLista";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";

interface IDetalleProgramaProps {
  loading?: boolean;
  items?: Array<IAuditoria>;
  item?: IAuditoria;
  is_test?: boolean;
}


export default function DetallePrograma({ loading = true, items, item, is_test }: IDetalleProgramaProps) {
  let search = new URLSearchParams(window.location.search);
  const idPrograma = parseInt(search.get("id") || "0");

  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [isLoading, setIsLoading] = useState(loading);
  const [isSendingData, setIsSendingData] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [programaSeleccionado, setProgramaSeleccionado] =
    useState<IAuditoria | null>(item || null);
  const [allAntecedentes, setAllAntecedentes] = useState<Array<IAuditoria>>(items || []);
  const [filtersState, setFiltersState] = useState<any>([]);
  const [isDownloading, setIsDownloading] = useState(false);
  usePromiseEffect(async () => {
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);
    setIsLoading(true);
    await pageLoad();
    setIsLoading(false);
  }, []);

  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any) => {
    return <RenderValue value={value} />;
  };

  const componentArchivo = (value: any) => {
    return <div>
      {value.row.original.ID_ESTADO > EnumEstadoAuditoria.PlanListo && (
        <i
          className="bi bi-file-earmark-arrow-down-fill iconDescarga"
          onClick={async () => {
            const path = PathsAuditoria.PlanAuditoriaPath(value.row.original.ID_PROGRAMA_AUDITORIA as number, value.row.original.ID as number);
            setIsDownloading(true);
            let flag = await AuditoriaService.GetContenidoArchivo(token, path);
            if (!flag) {
              await AuditoriaService.GenerarPDFPlan(token, value.row.original.ID as number);
              await AuditoriaService.GetContenidoArchivo(token, path);
            }
            setIsDownloading(false);
          }}
        ></i>
      )}
      {value.row.original.ID_ESTADO > EnumEstadoAuditoria.InformeListo && (
        <i
          className="bi bi-file-earmark-arrow-down-fill iconDescarga"
          onClick={async () => {
            const path = PathsAuditoria.InformeAuditoriaPath(value.row.original.ID_PROGRAMA_AUDITORIA as number, value.row.original.ID as number);
            setIsDownloading(true);
            let flag = await AuditoriaService.GetContenidoArchivo(token, path);
            if (!flag) {
              await AuditoriaService.GenerarPDFInforme(token, value.row.original.ID as number);
              await AuditoriaService.GetContenidoArchivo(token, path);
            }
            setIsDownloading(false);

          }}
        ></i>
      )}
    </div>;
  };

  const renderOpciones = (value: any) => {
    return <a
      className="text-decoration-none"
      href={`agregarauditoria?id=${value.ID_PROGRAMA_AUDITORIA}&idauditoria=${value.ID}`}
    >
      <i className="bi bi-pencil-square iconPencil"></i>
    </a>
  }


  const pageLoad = async () => {
    const params = {
      PAGINA: 1,
      PAGINADO: pageSize,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      ID: idPrograma,
    };
    let resultGetPrograma = (
      await getAPI(
        `${API_AUDITORIA}${API_AUDITORIA_GET_PROGRAMAAUDITORIA}`,
        { Authorization: `Bearer ${token}` },
        params
      )
    ).result;
    setProgramaSeleccionado(resultGetPrograma.data);

    let resultGetAllAntecedentes = (
      await getAPI(
        `${API_AUDITORIA}${API_AUDITORIA_GETALL_PLANESAUDITORIAS}`,
        { Authorization: `Bearer ${token}` },
        { ...params, ID_PROGRAMA_AUDITORIA: idPrograma }
      )
    ).result;
    setAllAntecedentes(resultGetAllAntecedentes.data);
    let pages = resultGetAllAntecedentes.pages;
    setPages(pages);
  };

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };

  const filter = async (
    filter: Partial<IAuditoria>,
    page: boolean = false,
    size = pageSize
  ) => {
    console.log(filter);
    if (!filter) {
      filter = {};
    }
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = 1;
    }
    if (!page) {
      filter.PAGINA = 1;
    }
    setPage(filter.PAGINA);

    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    if (filter.FECHA_DESDE) {
      filter.FECHA_DESDE = new Date(filter.FECHA_DESDE);
    }
    if (filter.FECHA_HASTA) {
      filter.FECHA_HASTA = new Date(filter.FECHA_HASTA);

    }


    let resultGetAllAntecedentes = is_test ? { result: { data: [], pages: 10 } } : await getAPI(
      `${API_AUDITORIA}${API_AUDITORIA_GETALL_PLANESAUDITORIAS}`,
      { Authorization: `Bearer ${token}` },
      { ...filter, ID_PROGRAMA_AUDITORIA: idPrograma }
    );
    setAllAntecedentes(resultGetAllAntecedentes.result.data);
    let pages = resultGetAllAntecedentes.result.pages;
    setPages(pages);
    setFiltersState(filter);
    console.log(filtersState);
  };

  const columnHelperMantIncCausa = createColumnHelper<IAuditoria>();
  let columnsDef = [
    columnHelperMantIncCausa.accessor((row) => row.CORRELATIVO, {
      id: "CORRELATIVO",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Código Auditoría"),
      title: "Código Programa",
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ESTADO, {
      id: "ESTADO_AUDITORIA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Estado Auditoría"),
      title: "Estado Programa",
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ID, {
      id: "OPCIONES",
      cell: (info: CellContext<IAuditoria, string>) => (
        renderOpciones(info.row.original)
      ),
      header: () => component("Opciones"),
      title: "Nombre Programa",
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.ID, {
      id: "ARCHIVO",
      cell: (info: CellContext<IAuditoria, string>) => (//   
        componentArchivo(info)
      ),
      header: () => component("Archivo"),
      title: "Año",
      tipo: ITipo_Campo.text,
      disableSorting: true,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.TIPO_AUDITORIA, {
      id: "TIPO_AUDITORIA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Tipo Auditoría"),
      title: "Fecha Aprobación",
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Vicepresidencia"),
      title: "Fecha Aprobación",
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Gerencia/Subgerencia"),
      title: "Fecha Aprobación",
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Unidad Proyecto"),
      title: "Fecha Aprobación",
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor(
      (row) => row.OBJETIVO_ALCANCE_EXCLUSIONES,
      {
        id: "OBJETIVO_ALCANCE_EXCLUSIONES",
        cell: (info: CellContext<IAuditoria, string>) => (
          componentValue(info.getValue())
        ),
        header: () => component("Objetivo Alcance y Exclusiones"),
        hide: false,
        title: "Fecha Aprobación",
        tipo: ITipo_Campo.text,
      } as any
    ),
    columnHelperMantIncCausa.accessor((row) => row.FECHA_DESDE, {
      id: "FECHA_DESDE",
      cell: (info: CellContext<IAuditoria, string>) => (
        componentValue(shortDate(info.getValue()))
      ),
      header: () => component("Fecha Inicio"),
      title: "Fecha Aprobación",
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.FECHA_HASTA, {
      id: "FECHA_HASTA",
      cell: (info: CellContext<IAuditoria, string>) => (
        componentValue(shortDate(info.getValue()))
      ),
      header: () => component("Fecha Término"),
      title: "Fecha Aprobación",
      tipo: ITipo_Campo.date,
    } as any),
    columnHelperMantIncCausa.accessor((row) => row.AUDITOR_LIDER_DISPLAY, {
      id: "AUDITOR_LIDER",
      cell: (info: CellContext<IAuditoria, string>) => componentValue(info.getValue()),
      header: () => component("Auditor Líder"),
      title: "Fecha Aprobación",
      tipo: ITipo_Campo.text,
    } as any),
    columnHelperMantIncCausa.accessor(
      (row) => row.AUDITORES_ACOMPANANTES_DISPLAY,
      {
        id: "AUDITORES_ACOMPANANTES",
        cell: (info: CellContext<IAuditoria, string>) => (
          componentValue(info.getValue())
        ),
        header: () => component("Auditores Acompañantes"),
        hide: false,
        title: "Fecha Aprobación",
        tipo: ITipo_Campo.text,
      } as any
    ),
  ] as any;
  return (
    <div>
      {
        isDownloading && <Loading key='loadingDownload' cssContainer="loadingFlotante" />
      }
      <div className="row">
        {isLoading ? (
          <Loading />
        ) : (
          <div className="col-12">
            <div className="rounded bg-white p-2 shadow">
              <div className="container-fluid mb-4">
                <h1 className="titPrincipal colorTit">Auditoría</h1>

                <div className="card bg-light border p-3 pt-2 mt-2">
                  <div className="row ajusteInput">
                    <div className="col-12">
                      <h6>
                        <span className="textSeccion">Antecedentes</span>
                      </h6>
                    </div>

                    <div className="col-sm-6 col-md-6 col-lg-4">
                      <label>Código Programa</label>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-8">
                      <p className="mb-2">{programaSeleccionado?.CORRELATIVO}</p>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                      <label>Estado Programa</label>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-8">
                      <p className="mb-2">{programaSeleccionado?.ESTADO}</p>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                      <label>Nombre Programa</label>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-8">
                      <p className="mb-2">{programaSeleccionado?.NOMBRE}</p>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                      <label>Año Auditoría</label>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-8">
                      <p className="mb-2">{programaSeleccionado?.ANIO}</p>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-4">
                      <label>Fecha Aprobación Auditoría</label>
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-8">
                      <p className="mb-2">
                        {shortDate(programaSeleccionado?.FECHA_APROBACION)}
                      </p>
                    </div>
                  </div>

                  <div className="" id="collapseGeneradas">
                    <div className="card card-body border-0 p-0 mt-2">
                      <div className="row">
                        <div className="col-12">
                          <div className="rounded bg-white p-2 shadow">
                            <div className="container-fluid mb-4">
                              <h1 className="titPrincipal colorTit mt-2"></h1>

                              <div className="row">
                                <div className="col-sm-6 col-md-6 col-lg-6 pt-0">
                                  <h6>
                                    <span className="textSeccion">
                                      Antecedentes Auditoría
                                    </span>
                                  </h6>
                                </div>

                                <div className="col-sm-6 col-md-6 col-lg-6 pt-0">
                                  {(allAntecedentes.filter(
                                    (a) =>
                                      a.ID_ESTADO ==
                                      EnumEstadoAuditoria.EnConstruccion
                                  ).length > 0) && programaSeleccionado?.ID_ESTADO == EnumEstadoProgramaAuditoria.EnConstruccion && (
                                      <button
                                        type="button"
                                        className="btn btn-sm btn-primary float-end me-2"
                                        onClick={async () => {
                                          setIsLoading(true);
                                          setIsSendingData(true);
                                          await postAPI(
                                            `${API_AUDITORIA}${API_AUDITORIA_POST_AUDITORIA_APROBARPROGRAMAAUDITORIA}`,
                                            {
                                              ID: idPrograma,
                                              EDITOR: currentUser?.email,
                                              EDITOR_DISPLAY: currentUser?.fullname,
                                              FECHA_MODIFICACION: new Date(),
                                              ENVIAR_NOTIFICACION: true,
                                            },
                                            {
                                              Authorization: `Bearer ${token}`,
                                            }
                                          );

                                          AuditoriaService.GenerarPDFPrograma(token, idPrograma);

                                          await pageLoad();

                                          setIsLoading(false);
                                          setIsSendingData(false);
                                        }}
                                        disabled={isSendingData}
                                      >
                                        <i className="bi bi-check-circle me-2"></i>{" "}
                                        Aprobar Programa y Auditorías
                                      </button>
                                    )}
                                  {(programaSeleccionado?.ID_ESTADO as number) >=
                                    EnumEstadoProgramaAuditoria.EnConstruccion && (<button
                                      type="button"
                                      className="btn btn-sm btn-primary float-end me-2"
                                      onClick={() => {
                                        window.location.href = `agregarauditoria?id=${programaSeleccionado?.ID}`;
                                      }}
                                      disabled={isSendingData}
                                    >
                                      <i className="bi bi-plus-circle me-2"></i>{" "}
                                      Agregar Auditoría
                                    </button>)}
                                </div>
                                <div className="col-12">
                                  <AdminLista
                                    hideAdd={true}
                                    hideExport={true}
                                    data={allAntecedentes}
                                    callback={() => { }}
                                    reload={() => {
                                      filter({});
                                    }}
                                    filter={filter}
                                    pagination={{
                                      pages: pages,
                                      page: page,
                                      paging: paging,
                                    }}
                                    tipo="Programaciones"
                                    columnsDef={columnsDef}
                                    isLoading={isLoading}
                                    callbackUpdatePageSize={(pageSize: number, filters: Object) => {
                                      setPageSize(pageSize);
                                      filter(filters, false, pageSize);
                                    }}
                                  />
                                </div>
                                <div className="col-sm-12 col-md-12 col-lg-12 mt-3">
                                  <button
                                    data-testid="btnvolver"
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    onClick={() =>
                                      (window.location.href = "/auditoria/home")
                                    }
                                    disabled={isSendingData}
                                  >
                                    <i className="bi bi-arrow-left-circle me-2"></i>{" "}
                                    Volver
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
